import React from 'react';
import {FormattedMessage, IntlShape} from 'react-intl';

export default class EmptyList extends React.Component {

    render() {
        return (
            <div className="CenteredContentHolder"><div className="CenteredContent">
				<FormattedMessage defaultMessage="Empty panel" id="emptyContent.emptyPanel" />
			</div></div>
        );
    }
}
